import { Checkbox } from "antd";
import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import { useSticky } from "react-table-sticky";
import { common_axios } from "../../../../App";
import { toast, ToastContainer } from "react-toastify";
import CheckBox from "../../Reacttable/UserManagement/ReactTableFiles/CheckBox";
import ColumnFilter from "../../Reacttable/UserManagement/ReactTableFiles/ColumnFilter";
import FilterListIcon from "@mui/icons-material/FilterList";
import TableViewIcon from "@mui/icons-material/TableView";
import PersonIcon from "@mui/icons-material/Person";
import Swal from "sweetalert2";
import {
  Backdrop,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextareaAutosize,
} from "@mui/material";
import Loader from "../../../../components/Loader";
import { SettingsInputComponent } from "@mui/icons-material";
import { dateFormatter } from "../../../../helper/helper";
// import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import SearchIcon from "@mui/icons-material/Search";
import CancelIcon from "@mui/icons-material/Cancel";
import { Link } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import * as React from "react";
import Pagination from "@mui/material/Pagination";
import {
  Stack,
} from "@mui/material";
export default function RechargeReports() {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);

  const [Status, setStatus] = useState({
    approveType: 1,
    resellerName: null,
    type: null,
    approveAssignedType: null,
    hideShow: false,
    pageNo: 0,
    pageSize: 10,
  });

  const [paginationPage, setPaginationPage] = React.useState(1);

  const customId1 = "custom-id-yes";

  const fetchUser = async () => {
    try {
      setOpen(true);
      const res = common_axios.post(
        `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/recharge/v1/fetch/recharge/count`,
        {
          role: JSON.parse(localStorage.getItem("Sidebaritems")).name,
        }
      );
      // const res1 = common_axios(
      //   `${
      //     process.env.REACT_APP_COMMON_API_DASHBOARD_API
      //   }/sms/campaign-report/v1/get/event-name?Role=${
      //     JSON.parse(localStorage.getItem("Sidebaritems")).name
      //   }`
      // );

      await Promise.all([res]).then((values) => {
        if (values?.[0]?.data?.statusDescription?.statusCode == 200) {
          //   setData1(values[0].data.listResellerNames);

          let obj = {};
          for (
            let index = 0;
            index < values?.[0]?.data?.rechargeCount?.length;
            index++
          ) {
            const element = values?.[0]?.data?.rechargeCount[index];

            if (element?.status == 0) {
              obj["pending"] = element?.count;
            }

            if (element?.status == 1) {
              obj["success"] = element?.count;
            }
            if (element?.status == 2) {
              obj["failed"] = element?.count;
            }
          }

          setData2({
            count: obj,
            // eventNames: values?.[1]?.data?.eventName,
          });

          setOpen(false);
        } else {
          setOpen(false);
          // toast.error(values[0].data.statusDescription.statusMessage, {
          //   theme: "colored",
          //   toastId: customId1,
          // });
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: values[0].data.statusDescription.statusMessage,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      });
    } catch (error) {
      setOpen(false);
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  useEffect(async () => {
    fetchUser();
  }, []);

  const fetchUserr = async () => {
    if (Status?.resellerName) {
      try {
        setOpen(true);

        const res = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/recharge/v1/save/details`,
          {
            rechargeRequest: {
              userId: localStorage.getItem("UserId"),
            },
          }
        );
        //   pageNo:
        //         Status?.pageNo == 0
        //           ? Status?.pageNo
        //           : Status?.pageNo < 0
        //           ? 0
        //           : Status?.pageNo - 1,

        if (res.data?.statusDescription?.statusCode == 200) {
          setData1(res.data?.playSmsOut);
          setData(res.data?.playSmsOut?.content);
          setOpen(false);
        } else if (res.data?.statusDescription?.statusCode == 220) {
          setData([]);
          setOpen(false);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.statusMessage,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        } else {
          setOpen(false);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.statusMessage,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      } catch (error) {
        setOpen(false);
        console.log(error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } else {
      try {
        setOpen(true);

        const res = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/recharge/v1/fetch/recharge/details`,

          {
            status: Status.approveType,
            pageNo: Status.pageNo,
            pageSize: Status.pageSize,

            role: JSON.parse(localStorage.getItem("Sidebaritems")).name,
          }
        );
        // rechargeRequest: {
        //   userId: localStorage.getItem("UserId"),
        // },
        //   pageNo:
        //         Status?.pageNo == 0
        //           ? Status?.pageNo
        //           : Status?.pageNo < 0
        //           ? 0
        //           : Status?.pageNo - 1,

        if (res.data?.statusDescription?.statusCode == 200) {
          setData1(res.data?.rechargeDetails);
          setData(res.data?.rechargeDetails?.content);
          setOpen(false);
        } else if (res.data?.statusDescription?.statusCode == 220) {
          setData([]);
          setOpen(false);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.statusMessage,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        } else {
          setOpen(false);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.statusMessage,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      } catch (error) {
        setOpen(false);
        console.log(error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    }
  };

  useEffect(async () => {
    fetchUserr();
  }, [Status.approveType, Status.pageSize, Status.pageNo]);

  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);

  const columns = useMemo(
    () => [
      // {
      //   Header: "S.no",

      //   accessor: "sno",
      //   Cell: (row, index) => {
      //     return <>{row.row.index + 1}</>;
      //   },
      // },
      {
        Header: "Id",
        accessor: "id",
        Cell: (cell) => {
          // console.log("cell--", cell.row.index);
          return <>{cell.row.index + 1 + Status?.pageNo * Status?.pageSize}</>;
        },
      },
      {
        Header: "Username",

        accessor: "rechargeUsername",
      },
      {
        Header: "Reacharge Date",

        accessor: "rechargeDate", // accessor is the "key" in the data
        // Cell: (cell) => {
        //   return <>{dateFormatter(cell.row.original.rechargeDate)}</>;
        // },
      },

      {
        Header: "Amount",

        accessor: "amount", // accessor is the "key" in the data
        Cell: (cell) => {
          return <>{cell.row.original.amount?.toLocaleString("en-US")}</>;
        },
      },

      {
        Header: "Status",

        accessor: "status",
        Cell: (cell) => {
          return (
            <>
              {cell.row.original.status == 0 ? (
                <div className="badge badge_8 bg-warning maxWidth_UP">
                  Pending
                </div>
              ) : cell.row.original.status == 1 ? (
                <div className="badge badge_8 bg-success maxWidth_UP">
                  Success
                </div>
              ) : (
                <div className="badge badge_8 bg-danger maxWidth_UP">
                  Failed
                </div>
              )}
            </>
          );
        },
      },
    ],
    [Status]
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      // initialState: { pageIndex: 1 }
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
    // useColumnOrder,
    // useBlockLayout,
    // useSticky,
    // (hooks) => {
    //   hooks.visibleColumns.push((columns) => {
    //     return [
    //       {
    //         id: "selection",
    //         Header: ({ getToggleAllRowsSelectedProps }) => (
    //           <CheckBox {...getToggleAllRowsSelectedProps()} />
    //         ),
    //         Cell: ({ row }) => (
    //           <CheckBox {...row.getToggleRowSelectedProps()} />
    //         ),
    //       },
    //       ...columns,
    //     ];
    //   });
    // }
  );

  const viewRefModal = useRef(null);

  const { globalFilter, pageIndex, pageSize } = state;

  const deletUser = () => {
    console.log({ selectedFlatRows });
  };

  return (
    <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
      <div className="container-fluid">
        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
          // onClick={handleClose}
        >
          <Loader />
        </Backdrop>
        <div className="card mb-3 mt-4">
          <div className="card-header p-3 pt-2">
            <div className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute">
              <PersonIcon
                style={{
                  color: "white",
                  fontSize: "27px",
                }}
              />{" "}
            </div>
            <div style={{ marginLeft: "6rem" }}>
              <p className="text-md text_top mb-0 text-capitalize text-start fw-bold d-inline">
                Recharge Report
              </p>
            </div>
          </div>

          <div className="card-body">
            <ul className="nav nav-tabs mt-2" id="myTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link ms-4 active position-relative"
                  id="SenderMasking-tab1"
                  data-bs-toggle="tab"
                  data-bs-target="#SenderMasking"
                  type="button"
                  role="tab"
                  aria-controls="SenderMasking"
                  aria-selected="false"
                  onClick={() => {
                    setStatus({
                      ...Status,
                      approveType: "1",
                      approveAssignedType: null,
                    });
                  }}
                >
                  Success
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-success">
                    {data2?.count?.success == null ? 0 : data2?.count?.success}
                  </span>
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link ms-4 position-relative"
                  id="home-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#AccountDetails"
                  type="button"
                  role="tab"
                  aria-controls="AccountDetails"
                  aria-selected="true"
                  onClick={() => {
                    setStatus({
                      ...Status,
                      approveType: "0",
                      approveAssignedType: null,
                    });
                  }}
                >
                  Pending
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-warning">
                    {data2?.count?.pending == null ? 0 : data2?.count?.pending}
                  </span>
                </button>
              </li>

              <li className="nav-item" role="presentation">
                <button
                  className="nav-link ms-4 position-relative"
                  id="SenderMasking-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#SenderMasking"
                  type="button"
                  role="tab"
                  aria-controls="SenderMasking"
                  aria-selected="false"
                  onClick={() => {
                    setStatus({
                      ...Status,
                      approveType: "2",
                      approveAssignedType: null,
                    });
                  }}
                >
                  Failed
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                    {data2?.count?.failed == null ? 0 : data2?.count?.failed}
                  </span>
                </button>
              </li>
            </ul>

            {/* {Status.approveType == "1" && (
              <ul className="nav nav-tabs mt-2" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link ms-4 position-relative"
                    id="SenderMasking-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#SenderMasking"
                    type="button"
                    role="tab"
                    aria-controls="SenderMasking"
                    aria-selected="false"
                    onClick={() => {
                      setStatus({
                        ...Status,
                        approveAssignedType: "0",
                      });
                    }}
                  >
                    Assigned
                    
                  </button>
                </li>

                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link ms-4 position-relative"
                    id="SenderMasking-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#SenderMasking"
                    type="button"
                    role="tab"
                    aria-controls="SenderMasking"
                    aria-selected="false"
                    onClick={() => {
                      setStatus({
                        ...Status,
                        approveAssignedType: "1",
                      });
                    }}
                  >
                    Not Assigned
                    
                  </button>
                </li>
              </ul>
            )} */}

            <div className="d-flex flex-wrap justify-content-between my-3">
              {Status.hideShow && (
                <>
                  <div className="d-flex">
                    {/* <Autocomplete
                      required
                      size="small"
                      disablePortal
                      id="combo-box-demo"
                      options={data2?.eventNames}
                      sx={{ width: 300 }}
                      //   getOptionLabel={(option) => `${option.eventName}`}
                      // value={Status.resellerName}
                      onChange={(e, val) => {
                        console.log({ val });
                        setStatus({
                          ...Status,
                          resellerName: val,
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          size="small"
                          required
                          {...params}
                          label="Select Event Name"
                        />
                      )}
                    /> */}

                    {/* <div
                      className="d-flex justify-content-between mx-3"
                      style={{ width: "300px" }}
                    >
                      <FormControl fullWidth>
                        <InputLabel size="small" id="test-select-label">
                          Select Type
                        </InputLabel>
                        <Select
                          size="small"
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={Status.type}
                          label="Select Type"
                          onChange={(e) => {
                            setStatus({
                              ...Status,
                              type: e.target.value,
                            });
                          }}
                        >
                          {[
                            { id: 0, name: "All", value: null },
                            {
                              id: 1,
                              name: "Promotional",
                              value: "Promotional",
                            },
                            {
                              id: 2,
                              name: "Transactional",
                              value: "Transactional",
                            },
                            {
                              id: 3,
                              name: "OTP",
                              value: "OTP",
                            },
                          ].map((d) => {
                            return (
                              <MenuItem value={d.value}> {d.name}</MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </div> */}

                    {/* <div className="d-flex justify-content-between ms-2">
                      <button
                        disabled={
                          Status.type == null && Status.resellerName == null
                        }
                        onClick={fetchUserr}
                        className={
                          Status.type == null && Status.resellerName == null
                            ? "btn btn-secondary"
                            : "btn btn-primary"
                        }
                      >
                        Filter
                      </button>
                    </div> */}
                  </div>
                </>
              )}

              {/* <div className="text-end" style={{ flexGrow: "1" }}>
                <IconButton
                  variant="text"
                  size="small"
                  sx={{
                    color: "#7B809A",
                  }}
                  onClick={(event) => {
                    setStatus({
                      ...Status,
                      hideShow: !Status.hideShow,
                    });
                  }}
                >
                  {Status.hideShow ? <CancelIcon /> : <SearchIcon />}
                </IconButton>
              </div> */}
            </div>

            {data?.length > 0 ? (
              <>
                {Status.hideShow && (
                  <>
                    <div className="d-flex justify-content-between my-3">
                      <div className="d-flex justify-content-between">
                        <select
                          value={Status.pageSize}
                          className="dropdown"
                          onChange={(e) => {
                            setPageSize(Number(e.target.value));
                            setStatus({
                              ...Status,
                              pageSize: e.target.value,
                            });
                          }}
                        >
                          {[10, 25, 50].map((value, i) => {
                            return (
                              <option
                                className="dropdown-menu"
                                aria-labelledby="dropdownMenuButton1"
                                value={value}
                                key={value}
                              >
                                Show {value}
                              </option>
                            );
                          })}
                        </select>
                      </div>

                      {/* <TextField
                        className="ms-4"
                        style={{
                          borderRadius: "4px",
                        }}
                        type="text"
                        label="Search"
                        name="Search"
                        variant="outlined"
                        // value={number}
                        size="small"
                        value={globalSearchValue || ""}
                        onChange={(e) => {
                          onChange(e.target.value);
                          setGlobalSearchValue(e.target.value);
                        }}
                      /> */}
                    </div>
                  </>
                )}

                <div className="text-end">
                  {selectedFlatRows.length > 0 && (
                    <button
                      onClick={deletUser}
                      className="btn bg-gradient-primary m-0"
                    >
                      Delete Users
                    </button>
                  )}
                </div>

                <div className="table-responsive">
                  <table
                    {...getTableProps()}
                    id="example"
                    className="table table-striped table-bordered dataTable table-sm mt-3"
                    style={{ width: "100%" }}
                  >
                    <thead>
                      {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                          {headerGroup.headers.map((column) => (
                            <th
                              {...column.getHeaderProps(
                                column.getSortByToggleProps()
                              )}
                              className="text-center width_2"
                            >
                              {column.render("Header")}
                              <span>
                                {column.isSorted
                                  ? column.isSortedDesc
                                    ? "↑"
                                    : "↓"
                                  : ""}
                              </span>
                            </th>
                          ))}
                        </tr>
                      ))}
                    </thead>
                    <tbody class='onhover_change' {...getTableBodyProps()}>
                      {page.map((row) => {
                        prepareRow(row);
                        return (
                          <tr {...row.getRowProps()}>
                            {row.cells.map((cell) => {
                              return (
                                <td
                                  {...cell.getCellProps()}
                                  // className="text-left"
                                  //   className={
                                  //   (cell.column.Header == "User Id" ||
                                  //     cell.column.Header == "Amount" ||
                                  //     cell.column.Header == "Start Date") &&
                                  //   "text-end"
                                  // }

                                  className={
                                    cell.column.Header == "Amount" ||
                                    cell.column.Header == "Id"
                                      ? "text-end"
                                      : cell.column.Header == "Status"
                                      ? "text-center"
                                      : "text-start"
                                  }
                                >
                                  {cell.render("Cell")}
                                </td>
                              );
                            })}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                <div className="d-flex justify-content-between mt-3">
                  <div>
                    <span>
                      Page:
                      <strong>
                        {data1?.pageable?.pageNumber + 1} of {data1?.totalPages}
                      </strong>
                    </span>
                  </div>


                  <div className="prev_next d-flex align-items-center">
                <button
                      className=" css-r93niq-MuiButtonBase-root-MuiPaginationItem-root m-0"
                      type="button"
                      // style={{ background: "#2C97D4" }}
                      //  disabled={data1?.pageable?.pageNumber == 0}
                      onClick={() => {
                       
                        setStatus({
                          ...Status,
                          pageNo:0,
                        });
                        setPaginationPage(1)
                      }}
                    >
                      First
                    </button>

                <Stack spacing={2}>
              <Pagination
                onChange={(event, value) => {
                  console.log("va--", value);
                  setStatus({
                    ...Status,
                    pageNo: Number(value) - 1,
                  });
                  setPaginationPage(value);
                }}
                page={paginationPage}
                count={data1? data1?.totalPages : ""}
               
                variant="outlined"
                shape="rounded"
                
            color="primary"
              />
            </Stack>
            <button
                      className=" css-r93niq-MuiButtonBase-root-MuiPaginationItem-root ms-2"
                      type="button"
                      // style={{ background: "#2C97D4" }}
                      // disabled={
                      //   data1?.totalPages == data1?.pageable?.pageNumber + 1
                      //  }
                      onClick={() => {
                        // alert("gg")
                        setStatus({
                          ...Status,
                          pageNo:data1?.totalPages -1 ,
                        });
                        setPaginationPage(data1?.totalPages)

                      }}
                    >
                      Last
                    </button>
                
              </div>
                  {/* <div>
                    <button
                      className="btn btn_primary "
                      type="button"
                      style={{ background: "#2C97D4" }}
                      disabled={data1?.pageable?.pageNumber == 0}
                      onClick={() => {
                        setStatus({
                          ...Status,
                          pageNo: Status.pageNo - 1,
                        });
                      }}
                    >
                      Prev
                    </button>

                    <button
                      className="btn btn_primary ms-2"
                      type="button"
                      style={{ background: "#2C97D4" }}
                      disabled={
                        data1?.totalPages == data1?.pageable?.pageNumber + 1
                      }
                      onClick={() => {
                        setStatus({
                          ...Status,
                          pageNo: Status.pageNo + 1,
                        });
                      }}
                    >
                      Next
                    </button>
                  </div> */}
                </div>
              </>
            ) : (
              <div className="text-center">
                {data?.length == 0 && open ? null : (
                  <div className="text-center mt-4">
                    <h5>No Record Found..!!</h5>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </main>
  );
}
